<template>
  <div id="customers-list" class="customers-list-container">

    <vs-popup title="Realmente deseja apagar este contato?" :active.sync="popupConfirmDelete">
        <vs-list>
            <vs-list-item :title="dataCustomer.name" :subtitle="'Telefone: ' + dataCustomer.phone_number">
              <template slot="avatar">
                <vs-avatar :src="dataCustomer.image" />
              </template>
            </vs-list-item>
        </vs-list>
        <div style="display: flex; justify-content: flex-end;">
          <vs-button style="margin-right: 10px;" radius color="primary" type="gradient" icon="undo" @click="popupConfirmDelete=false" />
          <vs-button radius color="danger" type="gradient" icon="delete" @click.stop="softDelete(dataCustomer.id)" />
        </div>
    </vs-popup>

    <customers-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :customer="sidebarData"
    />

    <customers-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @fetchCustomers="fetchCustomers"
    />

    <vs-table
      :sst="true"
      ref="table"
      @search="handleSearch"
      @sort="handleSort"
      noDataText="Sem dados disponíveis"
      :max-items="itemsPerPage"
      search
      :data="customers"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            v-if="canSee('add')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="addNewData"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>

          <div
            v-if="canSee('download')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="openModalToDownloadCustomers"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">
                Baixar Lista de Contatos
              </span>
          </div>

          <vs-dropdown>
            <vs-button class="mb-3" color="#636363" type="flat" icon="more_vert"></vs-button>
            <vs-dropdown-menu>
                <vs-dropdown-item v-if="canSee('delete') && showFuctionSelect !== true" class="content-dropdown" @click="activeSelectedGroup">
                  <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" />
                  Selecionar Contatos
                </vs-dropdown-item>
                <span v-if="hasErpFeature">
                  <vs-dropdown-item v-if="modalChoiceERP !== true" class="content-dropdown" @click="openModalToIntegration">
                    <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" />
                    Sincronizar com ERP
                  </vs-dropdown-item>
                </span>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button v-if="showFuctionSelect !== false && checkBox.length !== 0" class="mb-3" color="#636363" type="flat" icon="delete" @click="popupConfirmDeleteCustomers=true"></vs-button>
          <vs-button v-if="showFuctionSelect !== false" class="mb-3" color="#636363" type="flat" icon="close" @click="closeDeleteManyCustomers"></vs-button>
        </div>
        
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            v-if="showFuctionSelect !== true"
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    customers.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : customers.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="phone_number">Número</vs-th>
        <vs-th sort-key="email" v-if="hasEmailFeature">Email</vs-th>
        <vs-th sort-key="is_blacklisted">Status</vs-th>
        <vs-th sort-key="is_favorite">Favorito</vs-th>
        <vs-th sort-key="instance_id">Conexão</vs-th>
        <vs-th sort-key="erp_id" v-if="hasErpFeature">Origem</vs-th>
        <vs-th v-if="showFuctionSelect !== true">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-popup title="Realmente deseja apagar estes contatos?" :active.sync="popupConfirmDeleteCustomers">
              <vs-list :data="tr" :key="indextr" v-for="(tr, indextr) in listCustomersCheckBox">
                  <vs-list-item :title="tr.name" :subtitle="'Telefone: ' + tr.phone_number">
                    <template slot="avatar">
                      <vs-avatar :src="tr.image" />
                    </template>
                  </vs-list-item>
              </vs-list>
              <div style="display: flex; justify-content: flex-end;">
                <vs-button style="margin-right: 10px;" radius color="primary" type="gradient" icon="undo" @click="popupConfirmDeleteCustomers=false" />
                <vs-button radius color="danger" type="gradient" icon="delete" @click.stop="softDeleteManyCustomers" />
              </div>
          </vs-popup>
        
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" ref="vsTrElement">
            <vs-td v-if="showFuctionSelect === true">
              <vs-checkbox
                @click="tableCustomer(tr)"
                v-model="checkBox" 
                :vs-value="tr.id" 
              />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-phone-number font-medium truncate">{{ formatedPhoneNumber(tr.phone_number) }}</p>
            </vs-td>

            <vs-td v-if="hasEmailFeature">
              <p class="product-email font-medium truncate">{{ tr.email}}</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="getNumberStatusColor(tr.is_blacklisted_sms)" class="flex items-center" v-if="hasSmsFeature && tr.is_blacklisted_sms">
                {{ getNumberStatusNameSms(tr.is_blacklisted_sms) }}
              </vs-chip>
              <vs-chip :color="getNumberStatusColor(tr.is_blacklisted_email)" class="flex items-center" v-if="hasEmailFeature && tr.is_blacklisted_email">
                {{ getNumberStatusNameEmail(tr.is_blacklisted_email) }}
              </vs-chip>
              <vs-chip :color="((tr.is_blacklisted_sms === 1 && tr.is_blacklisted_email === 1 && tr.is_blacklisted === 0) || 
              (tr.is_blacklisted_sms === 1 && tr.is_blacklisted === 0) || (tr.is_blacklisted_email === 1 && tr.is_blacklisted === 0))
              ? 'white': getNumberStatusColor(tr.is_blacklisted )" class="flex items-center">
                {{ (tr.is_blacklisted_sms === 1 && tr.is_blacklisted_email === 1 && tr.is_blacklisted === 0)
              ? '': getNumberStatusName(tr.is_blacklisted) }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <vs-chip :color="getNumberFavoriteColor(tr.is_favorite)" class="product-order-status">
                {{ getNumberFavoriteName(tr.is_favorite) }}
              </vs-chip>
            </vs-td>

            <vs-td>
              {{ tr.instance ? (tr.instance.nickname ? tr.instance.nickname: tr.instance.name) : 'Sem Contato' }}
            </vs-td>

            <vs-td v-if="hasErpFeature">
              {{ tr.erp ? tr.erp.erp_name : 'Pedbot' }}
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('update') && showFuctionSelect !== true"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />

              <feather-icon
                v-if="canSee('delete') && showFuctionSelect !== true"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="popupCustomerDelete(tr)"
              />
              
            </vs-td>
              
            <template class="expand-user" slot="expand">
              <div v-if="showFuctionSelect !== true">
                <table-customer-category :customer-groups="tr.customer_groups" :customer-id="tr.id" />
              </div>
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <SyncErpModal :isActive="modalChoiceERP" @isActiveFalse="modalChoiceERP=false" v-if="hasErpFeature"/>
    
    <DownloadCustomers :isActive="modalDownloadCustomers" @isActiveFalse="modalDownloadCustomers=false"/>

    <vs-pagination
      :total="totalPages"
      v-model="currentPage"
      @change="closeExpand"
      :max="7"
    ></vs-pagination>
  </div>
</template>

<script>
  import CustomersViewSidebar from './CustomersViewSidebar'
  import TableCustomerCategory from './TableCustomerCategory'
  import { hasPermission, decodeFromBase64, hasFeature, maskPhoneNumber } from '@/utils'
  import SyncErpModal from "./CustomersSyncErpModal.vue";
  import DownloadCustomers from "./CustomersDownload.vue";

  import moduleCustomer from '@/store/customer/moduleCustomer'

  export default {
    name: 'customers-list',
    components: {
      CustomersViewSidebar,
      TableCustomerCategory,
      SyncErpModal,
      DownloadCustomers
    },
    data() {
      return {
        isBlacklistedSms: false,
        isBlacklistedEmail: false,
        switchCustomerSidebar:false,
        showFuctionSelect:false,
        currentPage: 1,
        itemsPerPage: 4,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        searchQuery: '',
        orderQuery: '',
        modalChoiceERP: false,
        modalDownloadCustomers: false,
        hasErpFeature: false,
        hasSmsFeature: false,
        hasEmailFeature: false,
        popupConfirmDelete:false,
        popupConfirmDeleteCustomers:false,
        dataCustomer: [],
        checkBox:[],
        listCustomersCheckBox: [],
      }
    },
    watch: {
      currentPage: function() {
        this.fetchCustomers()
      },
      itemsPerPage: function() {
        if (this.currentPage === 1) {
          this.fetchCustomers()
        } else {
          this.currentPage = 1
        }
      }
    },
    computed: {
      customers() {
        return this.$store.state.customer.customers
          ? this.$store.state.customer.customers.items
          : []
      },
      queriedItems() {
        return this.$store.state.customer.customers
          ? this.$store.state.customer.customers.total_items
          : 0
      },
      totalPages() {
        return this.$store.state.customer.customers
          ? this.$store.state.customer.customers.total_pages
          : 1
      },
      searchObject() {
        return {
          deleted_at: null,
          pagination_page: this.currentPage,
          pagination_limit: this.itemsPerPage
        }
      },
    },
    methods: {
      activeSelectedGroup() {
        this.showFuctionSelect = true
      },
      async handleSearch(searchQuery) {
        this.closeExpand();
        this.searchQuery = searchQuery
        this.currentPage = 1
        await this.fetchCustomers()
      },
      async handleSort(key, active) {
        this.closeExpand();
        if (!key) { return; }
        this.orderQuery = key+';'+active;
        await this.fetchCustomers()
      },
      popupCustomerDelete(data) {
        this.closeExpand();
        this.dataCustomer = data;
        this.popupConfirmDelete = true;
      },
      closeExpand() {
        let $target = [];
        this.$refs.vsTrElement.forEach((element) => {
          if (element.expanded === true) {
            $target.push(element)
          }
        })
        $target.forEach((element) => {
          element.$el.click();
        })
      },
      getNumberStatusName(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') { 
          return 'Bloqueado da Campanha WhatsApp'
        }else if(isBlacklisted !== true && isBlacklisted !== 'true' && isBlacklisted !== 1 && isBlacklisted !== '1' &&
              this.isBlacklistedSms !== true &&  this.isBlacklistedSms !== 'true' &&  this.isBlacklistedSms !== 1 &&  
              this.isBlacklistedSms !== '1' && this.isBlacklistedEmail !== true &&  this.isBlacklistedEmail !== 'true' &&  
              this.isBlacklistedEmail !== 1 &&  this.isBlacklistedEmail !== '1'){
            return 'Ativado'
        }
        return ''
      },
      getNumberStatusNameSms(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') { 
          return 'Bloqueado da Campanha Sms'
        }
        this.isBlacklistedSms = false
        return ''
      },
      getNumberStatusNameEmail(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') { 
          return 'Bloqueado da Campanha Email'
        }
        this.isBlacklistedEmail = false
        return ''
      },
      getNumberFavoriteName(isFavorite) {
        if (!(isFavorite !== false && isFavorite !== 'false' && isFavorite !== 0 && isFavorite !== '0')) { 
          return 'Não'
        }

        return 'Sim'
      },
      getNumberFavoriteColor(isFavorite) {
        if (!(isFavorite !== false && isFavorite !== 'false' && isFavorite !== 0 && isFavorite !== '0')) {
          return 'danger'
        }

        return 'success'
      },
      getNumberStatusColor(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') {
          return 'dark'
        }else if(isBlacklisted !== true && isBlacklisted !== 'true' && isBlacklisted !== 1 && isBlacklisted !== '1' &&
                this.isBlacklistedSms !== true &&  this.isBlacklistedSms !== 'true' &&  this.isBlacklistedSms !== 1 &&  
                this.isBlacklistedSms !== '1' && this.isBlacklistedEmail !== true &&  this.isBlacklistedEmail !== 'true' &&  
                this.isBlacklistedEmail !== 1 &&  this.isBlacklistedEmail !== '1'){
          return 'success'
        }
        return 'white'
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      tableCustomer(data) {
        if (!this.listCustomersCheckBox.includes(data) && !this.checkBox.includes(data.id)) {
          this.listCustomersCheckBox.push(data)
        } else if (this.listCustomersCheckBox.indexOf(data) === -1) {
          this.listCustomersCheckBox.forEach((customer, index) => {
            if (customer.id === data.id) {
              this.listCustomersCheckBox.splice(index, 1)
            }
          })
        } else {
          this.listCustomersCheckBox.splice(this.listCustomersCheckBox.indexOf(data), 1)
        }
      },
      openModalToIntegration() {
        this.showFuctionSelect = false;
        this.modalChoiceERP = true;
      },
      openModalToDownloadCustomers() {
        this.modalDownloadCustomers = true;
      },
      closeDeleteManyCustomers() {
        this.listCustomersCheckBox = []
        this.checkBox = []
        this.showFuctionSelect = false;
      },
      softDeleteManyCustomers() {
        this.popupConfirmDeleteCustomers = false;
        this.listCustomersCheckBox = []
        this.itemsPerPage = 4;
        this.checkBox.forEach(data => {
            this.softDelete(data)
        }) 
        this.showFuctionSelect = false;
        this.checkBox = []
      },
      softDelete(customerId) {
        const that = this
        this.popupConfirmDelete = false
        this.$store.dispatch("customer/softDelete", customerId).then(() => {
          that.fetchCustomers()
          this.$vs.notify({
              title: "Sucesso",
              text: "Contato deletado com sucesso",
              color: "success",
          });
        }).catch(err => { console.error(err) })
      },
      editData(data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = this.$_.cloneDeep(data)
        try {
          let openFielDecode = decodeFromBase64(this.sidebarData.open_field)
          this.sidebarData.open_field = openFielDecode != 'null' ? openFielDecode : '';
        } catch (error) {
          console.log(error)
        }
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
      },
      async fetchCustomers(searchObject = null) {
        searchObject = searchObject || this.searchObject
        this.$store.dispatch("customer/fetch", {
          ...searchObject,
          search_query: this.searchQuery,
          order_query: this.orderQuery
        })
      },
      formatedPhoneNumber(phoneNumber) {
          return maskPhoneNumber(phoneNumber)
      }
    },
    created() {
      if (!moduleCustomer.isRegistered) {
        this.$store.registerModule('customer', moduleCustomer)
        moduleCustomer.isRegistered = true
      }

      this.fetchCustomers()
    },
    async mounted() {
      this.isMounted = true;
      this.hasErpFeature = await hasFeature('erps')
      this.hasSmsFeature = await hasFeature('sms')
      this.hasEmailFeature = await hasFeature('email')
    },
    beforeRouteLeave(to, from, next) {
      if (this.modalDownloadCustomers) {
        this.modalDownloadCustomers = false;
        setTimeout( ()=> {
          next();
        }, 2);
      } 
      else if (this.modalChoiceERP) {
        this.modalChoiceERP = false;
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else if (this.popupConfirmDelete) {
        this.popupConfirmDelete = false;
        setTimeout( ()=> {
          next();
        }, 2);
      }
      else {
        next();
      }
    },
  }
</script>

<style lang="scss">
  #customers-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>

<style>
  .content-dropdown {
    font-size: 1em;
    margin-top: 0.25em;
  }
</style>
